import { render, staticRenderFns } from "./SMSTemplateTest.vue?vue&type=template&id=11d288f6&scoped=true&"
import script from "./SMSTemplateTest.vue?vue&type=script&lang=js&"
export * from "./SMSTemplateTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d288f6",
  null
  
)

export default component.exports